import { render, staticRenderFns } from "./notifyDetail.vue?vue&type=template&id=3d313a0d&scoped=true&"
import script from "./notifyDetail.vue?vue&type=script&lang=js&"
export * from "./notifyDetail.vue?vue&type=script&lang=js&"
import style0 from "./notifyDetail.vue?vue&type=style&index=0&id=3d313a0d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d313a0d",
  null
  
)

export default component.exports